angular.module('rjmNg.directives').directive "validatePassword", [
  () ->
    require: 'ngModel'
    restrict: 'A'
    link: (scope, ele, attrs, controller) ->
      # There are 3 optional parameters for this directive:
      # - match (check that a password matches with the ngModel given in match)
      # - resetValidity (watch the given scope variable for a change. reset validity on change.)
      # - resetError (make scope error variable resetError null to prevent overlapping errors.)

      # var initializing used to prevent error messages from
      # showing right away.
      initializing = true

      scope.$watch attrs.ngModel, (value) ->
        if not initializing
          controller.$setDirty()

          if not value? or value.length < 6 or not value.match(/\d/)
            controller.$setValidity('validPassword', false)
          else
            controller.$setValidity('validPassword', true)
            controller.$setValidity('required', true)
        initializing = false

        if attrs.match?
          controller.$setValidity 'matchingPassword', scope.$eval(attrs.match) == value

      scope.$watch attrs.resetValidity, (value) ->
        controller.$setValidity('validPassword', true)
        controller.$setValidity('matchingPassword', true)
        controller.$setValidity('required', false)

        controller.$setPristine()
  ]
